export default "__VITE_ASSET__BwwittMK__"